/* eslint-disable no-undef */ /* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import { t } from 'i18next';
import { useState, useEffect } from 'react';
import { Marker, useMap } from '@vis.gl/react-google-maps';

import { notify } from 'src/utils/helper';

import { useTranslate } from 'src/locales';

const customIcons = {
  pickup: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
  delivery1: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
  delivery2: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
};

export default function RouteMap({
  pickupPoint,
  delivery1Point,
  delivery2Point,
  onMarkerDragEnd, // function(pointKey, latLng)
  onDirection,
  isSmall,
}) {
  const map = useMap();
  const [directionsRenderer, setDirectionsRenderer] = useState(null);
  const [directions, setDirections] = useState();
  const { currentLang } = useTranslate();

  const points = [pickupPoint, delivery1Point, delivery2Point].filter(Boolean);

  // ⛳️ Traffic Layer
  useEffect(() => {
    if (!map) return;

    // Un-Comment when Traffic is required
    // const trafficLayer = new google.maps.TrafficLayer();
    // trafficLayer.setMap(map);
    // return () => trafficLayer.setMap(null); // Clean up
  }, [map]);

  // 🧭 Handle Directions
  useEffect(() => {
    if (!map || points.length < 2) return;

    const directionsService = new google.maps.DirectionsService();

    if (directionsRenderer) {
      directionsRenderer.setMap(null);
    }

    const renderer = new google.maps.DirectionsRenderer({
      map,
      suppressMarkers: true,
      polylineOptions: {
        strokeColor: '#4285F4',
        strokeWeight: 5,
      },
    });

    setDirectionsRenderer(renderer);

    const origin = pickupPoint;
    const destination = delivery2Point || delivery1Point;
    const waypoints = [];

    if (pickupPoint && delivery1Point && delivery2Point) {
      waypoints.push({ location: delivery1Point, stopover: true });
    }

    directionsService.route(
      {
        origin,
        destination,
        waypoints,
        travelMode: google.maps.TravelMode.DRIVING,
        avoidFerries: true,
        provideRouteAlternatives: false,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          renderer.setDirections(result);
          setDirections(result.routes[0].bounds);
          onDirection?.(result.routes[0]);
        } else {
          console.error('Directions request failed:', status);
          onDirection?.(null);
          if (status === 'ZERO_RESULTS') {
            notify('error', t('No_route_found_Please_select_another_location'));
          }
        }
      }
    );

    return () => renderer.setMap(null);
  }, [pickupPoint, delivery1Point, delivery2Point, map]);

  useEffect(() => {
    if (!map || !directions) return;

    // ✅ Only fit bounds if there are at least 2 valid points (origin + destination)
    const hasRoute =
      pickupPoint &&
      ((delivery1Point && delivery1Point.lat) || (delivery2Point && delivery2Point.lat));

    if (!hasRoute) return; // skip fitBounds when showing only current pickup location

    map.fitBounds(directions, { top: 50, bottom: 50, left: 0, right: 0 });

    // Slight delay to ensure projection + fitBounds finish
    setTimeout(() => {
      const currentCenter = map.getCenter();
      if (!currentCenter) return;

      const latOffset = -0.01; // move up/down (+ = up)
      const lngOffset = 0; // move left/right (- = right)

      map.setCenter({
        lat: isSmall ? currentCenter.lat() : currentCenter.lat() + latOffset,
        lng: isSmall ? currentCenter.lng() : currentCenter.lng() + lngOffset,
      });

      const currentZoom = map.getZoom();
      map.setZoom(currentZoom - 1);
    }, 300);
  }, [map, directions, pickupPoint, delivery1Point, delivery2Point, isSmall]);

  // 📍 Marker Component
  const renderMarker = (point, key, icon) => {
    if (!point) return null;

    return (
      <Marker
        key={key}
        animation={google.maps.Animation.DROP}
        position={point}
        draggable
        // icon={{
        //   url: icon,
        //   scaledSize: new google.maps.Size(40, 40),
        // }}
        onDragEnd={(e) => onMarkerDragEnd?.(key, e.latLng)}
      />
    );
  };

  return (
    <>
      {renderMarker(pickupPoint, 'pickupLocationDetails', customIcons.pickup)}
      {renderMarker(delivery1Point, 'delivery_1_LocationDetails', customIcons.delivery1)}
      {renderMarker(delivery2Point, 'delivery_2_LocationDetails', customIcons.delivery2)}
    </>
  );
}
